/*gsap.from('.mksun-block-steps .mksun-block-steps__ctn__introduction__img .img-ctn', {
      width: 0,
      scrollTrigger: '.mksun-block-steps .mksun-block-steps__ctn__introduction__img .img-ctn'
  })*/

//const widthTranslateStep = document.querySelector(".mksun-block-steps .mksun-block-steps__ctn__steps").clientWidth + 32 + 64;

import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
const isMobileFirstLoad = window.innerWidth < 768;


const tlSteps = gsap.timeline({
    scrollTrigger: {
        trigger: '.mksun-block-steps'

        //start: 'center center',
        //end: 'center+=66% center',
        //pin: true,
        //pinSpacing: true,
        //markers: true,
        /*onUpdate: (self) => {
      gsap.to('.mksun-block-steps .mksun-block-steps__ctn', {
          translateX: -self.progress * widthTranslateStep + "px",
      })
  }*/
    }
});

if (!isMobileFirstLoad) {
    const titleSteps = new SplitText(
        '.mksun-block-steps .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words'
        }
    );

    const linesSteps = new SplitText('.mksun-block-steps .timeline-text-reveal--lines', {
        type: 'lines'
    });

    tlSteps.fromTo('.mksun-block-steps__ctn__introduction__img',
        {
            width: 0,
        },
        {
            width: '100%',
            onComplete: () => {
                gsap.set('.mksun-block-steps__ctn__introduction__img__overlay', {
                    left: "unset",
                    right: 0
                })
            }
        }).to('.mksun-block-steps__ctn__introduction__img__overlay',{
            width: 0
    })


    /*tlSteps.from(
        '.mksun-block-steps .mksun-block-steps__ctn__introduction__img .img-ctn',
        {
            width: 0,
            duration: 0.5,
            ease: 'power1.out'
        },
        '<'
    );*/

    tlSteps.from(
        titleSteps.words,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlSteps.from(
        linesSteps?.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );
}

tlSteps.to(
    '.mksun-block-steps .btn',
    {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power1.out'
    },
    '<'
);});